import { Injectable } from '@angular/core';
import { CanActivate,
         CanActivateChild,
         Router,
         ActivatedRouteSnapshot,
         RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class LoggedInGuard implements CanActivate, CanActivateChild {
  constructor(private user: AuthService, private router:Router) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.user.isLoggedIn()) {return true;}

    this.user.redirectUrl = state.url;

    this.router.navigate(['/login']);
    return false;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-router-loader/src!./~/angular2-template-loader!./src/app/auth/logged-in.guard.ts
 **/